import { render } from "./music.vue?vue&type=template&id=14e99c8f&scoped=true"
import script from "./music.vue?vue&type=script&lang=js"
export * from "./music.vue?vue&type=script&lang=js"

import "./music.vue?vue&type=style&index=0&id=14e99c8f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-14e99c8f"

export default script